module.exports = __webpack_public_path__ + "static/img/banner.5dc29d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/banner.jpg
// module id = uHk9
// module chunks = 1